import React, { useState } from "react";
import classes from "./SignUpPage.module.scss";
import { ReactComponent as SolarImage } from "../assets/images/solarSystemImage.svg";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import SignUpOne from "./SignUpOne";
import SignUpTwo from "./SignUpTwo";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { BsGlobe2 } from "react-icons/bs";

const SignUpPage = ({
  handleChange,
  showAuthLoader,
  userSignUp,
  first_name,
  last_name,
  phone,
  email,
  password,
  cPassword,
  merchant_code,
  are_guideline_accepted,
  phoneValidations,
  passwordValidations,
  isCommonPassword,
  validNumber,
  validOneUpperCase,
  validOneDot,
  validEightCharacter,
  emailValidations,
  showMessage,
  success,
  alertMessage,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t, i18n } = useTranslation();
  const [steps, setSteps] = useState(0);
  const [lang, setLang] = useState("fa");

  const handleDecreaseSteps = () => {
    setSteps(0);
  };

  const handleIncreaseSteps = () => {
    setSteps(steps + 1);
  };

  const handleCheckValidation = () => {
    if (steps === 0) {
      let unValid = [
        first_name?.length >= 3,
        last_name?.length >= 3,
        emailValidations,
        passwordValidations,
        !isCommonPassword,
      ].every((valid) => valid === true);
      return !unValid;
    } else if (steps === 1) {
      return !phoneValidations || !are_guideline_accepted;
    } else {
      return false;
    }
  };

  function changeLanguage() {
    if (lang === "en") {
      setLang("fa");
    } else {
      setLang("en");
    }
    i18next.changeLanguage(lang === "en" ? "fa" : "en");
  }

  return (
    <>
      <div className="app-login-main-content">
        <div className="app-logo-content d-flex align-items-center justify-content-center">
          <span
            onClick={() => {
              window.location.replace("https://www.vkitaki.ir/fa/home");
            }}
            style={{
              position: " absolute",
              top: "25px",
              left: "35px",
              fontSize: "1rem",
              cursor: "pointer",
            }}
          >
            <span className="m-0 ">{t("sign_in.back_to_website")}</span>
            <ArrowBackIcon style={{ fontSize: "1.3rem" }} />
          </span>
          <div className="logo-lg">
            <SolarImage className="app-logo-content-logo" />
            <h1 className="bolder-text">{t("sign_up.to_world_wide")}</h1>
          </div>
        </div>
        <div className="app-login-content">
          <span onClick={() => changeLanguage()} className={classes.lang}>
            <span className={classes.title}>{t("sign_in.language")}</span>
            <BsGlobe2
              style={{ margin: "1px 5px", fontSize: "16px" }}
              fontSize={"small"}
            />
          </span>
          <div className="mb-4">
            <h2>
              {steps === 0 && t("sign_up.sign_up")}
              {steps === 1 && t("sign_up.sign_up")}
            </h2>
          </div>

          <div className="app-login-form">
            <form>
              <fieldset>
                <div className="app-login-form-inputs">
                  {steps === 0 && (
                    <SignUpOne
                      handleChange={handleChange}
                      first_name={first_name}
                      last_name={last_name}
                      email={email}
                      password={password}
                      cPassword={cPassword}
                      passwordValidations={passwordValidations}
                      emailValidations={emailValidations}
                      validNumber={validNumber}
                      validOneUpperCase={validOneUpperCase}
                      validOneDot={validOneDot}
                      validEightCharacter={validEightCharacter}
                      isCommonPassword={isCommonPassword}
                    />
                  )}
                  {steps === 1 && (
                    <SignUpTwo
                      handleChange={handleChange}
                      phone={phone}
                      phoneValidations={phoneValidations}
                      merchant_code={merchant_code}
                      are_guideline_accepted={are_guideline_accepted}
                      handleDecreaseSteps={handleDecreaseSteps}
                    />
                  )}
                </div>

                <div className={classes.buttonRoot}>
                  <Button
                    variant="contained"
                    className="btn btn-primary jr-btn-uptin"
                    onClick={
                      steps === 1
                        ? () => {
                            showAuthLoader();
                            userSignUp({
                              first_name,
                              last_name,
                              email,
                              phone,
                              password,
                              merchant_code,
                              are_guideline_accepted,
                            });
                          }
                        : () => handleIncreaseSteps()
                    }
                    disabled={handleCheckValidation()}
                  >
                    {steps === 0 && t("sign_up.next_step")}
                    {steps === 1 && t("sign_up.ok")}
                  </Button>
                  <span className={classes.signInLink}>
                    <Link to="/signin">{t("sign_up.already_user")}</Link>
                  </span>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
      {showMessage &&
        enqueueSnackbar(alertMessage, {
          variant: `${success ? "success" : "error"}`,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          autoHideDuration: 3000,
        })}
    </>
  );
};

export default SignUpPage;
